import { buildDocumentDesignPdf, validateDocumentDesign } from './processDocumentDesign.js';
const BUCKET = 'mfg-product-docs';

export async function loadProcessDocumentDesign(document) {
  const { supabase } = await import('./supabase.js');
  const storage = supabase.storage.from(BUCKET);
  const { data, error } = await storage.download(document.design_storage_path);
  if (error) throw error;
  const design = validateDocumentDesign(JSON.parse(await data.text()));
  if (!design.image.storage_path) throw new Error('El diseño no contiene la imagen original.');
  const result = await storage.download(design.image.storage_path);
  if (result.error) throw result.error;
  return { design, imageFile: new File([result.data], 'imagen.png', { type: 'image/png' }) };
}

export async function saveDesignedProcessDocument({ design, imageFile, document = {}, processLineId, metadata }, dependencies = {}) {
  validateDocumentDesign(design);
  if (!imageFile) throw new Error('Inserta una imagen antes de guardar.');
  if (!dependencies.saveRecord) {
    const { supabase } = await import('./supabase.js');
    const { error } = await supabase.from('mfg_cost_sheet_process_documents').select('design_storage_path,design_revision').limit(1);
    if (error) throw new Error(['42703', 'PGRST204'].includes(error.code)
      ? 'El editor necesita activar la actualización de la base de datos de documentos antes de guardar.' : error.message);
  }
  const storage = dependencies.storage || (await import('./supabase.js')).supabase.storage.from(BUCKET);
  const saveRecord = dependencies.saveRecord || (await import('./api/manufacturing.js')).saveProcessDocument;
  const pdf = await buildDocumentDesignPdf(design, new Uint8Array(await imageFile.arrayBuffer()));
  const filename = `ficha-${String(design.article || 'articulo').replace(/[^a-zA-Z0-9._-]/g, '-')}.pdf`;
  const prefix = `process-lines/${processLineId}/${document.id || crypto.randomUUID()}/${crypto.randomUUID()}`;
  const imagePath = `${prefix}/imagen.png`, designPath = `${prefix}/diseno.json`, pdfPath = `${prefix}/${filename}`;
  const bytes = await pdf.save(), uploaded = [];
  try {
    for (const [path, blob] of [
      [imagePath, imageFile],
      [designPath, new Blob([JSON.stringify({ ...design, image: { ...design.image, storage_path: imagePath } })], { type: 'application/json' })],
      [pdfPath, new Blob([bytes], { type: 'application/pdf' })],
    ]) {
      const { error } = await storage.upload(path, blob, { upsert: false, contentType: blob.type });
      if (error) throw error;
      uploaded.push(path);
    }
    const result = await saveRecord({ ...document, ...metadata, title: design.title, process_line_id: processLineId,
      storage_path: pdfPath, external_url: '', file_name: filename, mime_type: 'application/pdf', file_size_bytes: bytes.length,
      design_storage_path: designPath, design_version: design.version, expected_design_revision: document.design_revision || 0 }, document.id || null);
    if (result.error) throw result.error;
    return result.data;
  } catch (error) {
    // Only discard files from this failed attempt; earlier designs may be referenced by duplicates.
    if (uploaded.length) { try { await storage.remove(uploaded); } catch { /* retain the original save error */ } }
    throw error;
  }
}
